import { useRestApiHeaders } from 'business/contextProviders/useApiHeaders';
import { useIndicatorV1ControllerGetList } from 'generated/apiComponents';
import { Module_Enum } from 'generated/graphql';

export const useGetDefectIndicatorData = (constructionSiteId: string) => {
  const restHeaders = useRestApiHeaders(Module_Enum.QualityControl);

  const { data, isLoading, refetch } = useIndicatorV1ControllerGetList({
    pathParams: {
      constructionSiteId,
    },
    headers: restHeaders,
  });

  const indicators = data?.indicators ?? [];

  return {
    indicators,
    hasIndicators: indicators.length > 0,
    isLoading,
    refetch,
  };
};
